import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TablePaginationExhibit2 as TablePagination2 } from "../../../common/table/table-pagination.component";
import { requestLogActions } from "./../../../../store/external/request-reducer/request-log.reducer";
import { requestDetailsActions } from "./../../../../store/external/request-reducer/request-details.reducer";
import { REQUEST_SUB_LINKS as RequestTable, TABLE_PAGINATION_KEY } from "../../../../constants/external-constants";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import "./../request-page.component.css";
import { TablePagination } from "../../../common/details-table/table-pagination.component";

class OrderRequestTable extends Component {
    constructor(props) {
        super();
    }

    componentDidMount() {
        this.props.isDisplaySearch(false);
        this.props.setActiveRequestTable(RequestTable.orderRequest.id);
        this.props.fetchRequestLogItems();
    }

    componentWillUnmount() {
        this.props.isDisplaySearch(false);
        this.props.setResetSearch();
        this.props.resetRequestLogData();
    }

    openRequestModal = (item) => {
        const { setSelectedRequest, history } = this.props;
        setSelectedRequest(item);
        history.push("MyRequest/RequestDetail/Order/" + item.OrderId);
    };

    onColumnSearch = () => {
        const { fetchRequestLogItems } = this.props;
        fetchRequestLogItems(0, RequestTable.orderRequest.id);
    }

    resizePage = (pageSize) => {
        const { resizeRequestLogs, fetchRequestLogItems } = this.props;
        resizeRequestLogs(pageSize)
        fetchRequestLogItems(0, RequestTable.orderRequest.id);
    }

    render() {
        const { orderRequestData, orderRequestLoaded, orderRequestFetchError, fetchRequestLogItems, fetchSortedRequestData, setRequestSearchValue } = this.props;
        let noAccess = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MyRequestsR, ACCESS_MODULE.MyRequestsRE, ACCESS_MODULE.MyRequestsRW]);

        return (
            <div>
                {
                    noAccess ?
                    <NoSubscription hideIcon={true} title="Forbidden Access" /> :
                    orderRequestLoaded ?
                        orderRequestFetchError ?
                            <span> Error in fetching data. </span> :
                            <TablePagination 
                                id={RequestTable.orderRequest.id}
                                tablePaginationKey={TABLE_PAGINATION_KEY.requestMyRequest}
                                columns={orderRequestData.Headers}
                                pageList={orderRequestData.Data}
                                pages={orderRequestData.Pagination}
                                rowClickAction={this.openRequestModal}
                                paginationAction={fetchRequestLogItems}
                                onColumnClick={fetchSortedRequestData}
                                onColumnSearch={() => { this.onColumnSearch() }}
                                onColumnSearchChange={setRequestSearchValue}
                                isColSearchShow={this.props.displaySearch}
                                totalPage={orderRequestData.Pagination.TotalEntries}
                                resizePage={this.resizePage}
                                key="table-pagination-sec"
                                classNameWrapper="overflow-auto" 
                            />
                            :
                        <div>
                            <NoSubscription customClass="loading-page" title="Loading, Please Wait…" />
                        </div>
                }
            </div>
        );
    }
}

export default connect(
    state => {
        const { requestLog } = state;
        return {
            ...requestLog
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, requestLogActions, requestDetailsActions),
            dispatch
        )
)(OrderRequestTable);
